module.exports = __webpack_public_path__ + "img/about_002.4592312.png";